var HUB_QUERY_KEY = 'hub';
var hubDomainKeys = {
  hub: [HUB_QUERY_KEY],
  myHubs: function myHubs(userId) {
    return [HUB_QUERY_KEY, userId ? userId : 'me'];
  }
};
export default hubDomainKeys;